import styled from 'styled-components';
import { selectColor } from '@panel/commons';

const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  color: ${selectColor('gray100')};
  margin-top: ${props => (props.isBrasil ? '90px' : '70px')};
  padding: 16px 16px 0px 16px;
  h2 {
    margin-bottom: 8px;
    font-size: 28px;
    font-weight: 700;
  }
  @media (min-width: 1201px) {
    display: none;
  }
`;

const FilterButton = styled.button`
  font-size: 16px;
  margin-top: 10px;
  height: 45px;
  width: 48%;
  border: 1px solid ${selectColor('grayMediumLight')};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  p {
  }
  img {
    margin-right: 6px;
    margin-bottom: 4px;
  }
`;

const TotalCount = styled.div`
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  margin-top: 16px;
  font-size: 16px;
  strong {
    margin-left: 5px;
  }
`;

const ActionsRow = styled.div`
  display: flex;
  margin: 5px 0;
  justify-content: space-between;
`;

const NoCredits = styled.div`
  color: ${selectColor('grayDark')};
  font-size: 14px;
  border: 1px solid ${selectColor('grayMediumLight')};
  border-radius: 0px 0px 6px 6px;
  padding: 10px 0px 10px 12px;
`;

const AlertContainer = styled.div`
  margin: ${({ setMargin }) => setMargin || '0 0 20px'};
  width: ${({ setWidth }) => setWidth || 'auto'};
  position: relative;
`;

export { TotalCount, ActionsRow, FilterButton, ContentLayout, NoCredits, AlertContainer };
